module.exports = __webpack_public_path__ + "img/gift-classics3.ed309a9.png";